:host {
  display: block;
}

.title {
  font-family: var(--primary-font);
  color: var(--color-nero);
  display: flex;
  flex-direction: column;
  row-gap: 24px;

  @include breakpointMax('sm') {
    row-gap: 16px;
  }

  &.left {
    text-align: left;
  }

  &.center {
    text-align: center;
  }

  &.right {
    text-align: right;
  }

  &.form-wrapper {
    margin-bottom: 15px;

    @include breakpointMin('lg') {
      margin-bottom: 30px;
    }
  }
}
